import { useMutation } from '@tanstack/react-query';

import services from '@/services';
import type { GetSingleSurveyResponseReport } from '@/services/surveyService';

export const useGetSingleSurveyResponseReportMutation = () => {
   return useMutation({
      mutationFn: async ({
         responseId,
         surveyId,
      }: Omit<GetSingleSurveyResponseReport, 'surveyId'> & {
         surveyId?: string;
      }) => {
         if (!surveyId) {
            throw new Error('Survey ID is required');
         }

         return services.survey.getSingleSurveyResponseReport({
            surveyId,
            responseId,
         });
      },
   });
};
